"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("@pbl/pbl-react-core/lib/models/profile/types");
var redux_persist_1 = require("redux-persist");
var storage_1 = __importDefault(require("redux-persist/lib/storage"));
var action_type_util_1 = require("../../action-type.util");
var INITIAL_STATE = {
    userProfile: {},
    error: null,
    loading: false,
    updateSucceeded: false,
    twitterRequestToken: null,
    updateFailed: false,
    validating: false,
    validationSucceeded: null,
    hasSeenTicketCheckerInstructions: false,
    checkTermsAndConditions: null
};
var ProfileReducer = function (state, action) {
    if (state === void 0) { state = INITIAL_STATE; }
    switch (action.type) {
        case (0, action_type_util_1.REQUEST)(types_1.GET_PROFILE):
        case (0, action_type_util_1.REQUEST)(types_1.GET_TERMS_AND_CONDITIONS):
        case (0, action_type_util_1.REQUEST)(types_1.GET_TWITTER_REQUEST_TOKEN):
        case (0, action_type_util_1.REQUEST)(types_1.GET_TWITTER_OAUTH_TOKEN):
        case (0, action_type_util_1.REQUEST)(types_1.GET_INSTAGRAM_ACCESS_TOKEN):
        case (0, action_type_util_1.REQUEST)(types_1.UPDATE_PROFILE):
            return __assign(__assign({}, state), { loading: true });
        case (0, action_type_util_1.FAILURE)(types_1.GET_PROFILE):
            return __assign(__assign({}, state), { loading: false, error: action.payload.message });
        case (0, action_type_util_1.FAILURE)(types_1.UPDATE_PROFILE):
            return __assign(__assign({}, state), { loading: false, error: action.payload.message, updateSucceeded: false });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_PROFILE):
            return __assign(__assign({}, state), { userProfile: action.payload, loading: false });
        case (0, action_type_util_1.SUCCESS)(types_1.UPDATE_PROFILE):
            return __assign(__assign({}, state), { userProfile: action.payload, loading: false, updateSucceeded: true });
        case (0, action_type_util_1.SUCCESS)(types_1.VERIFY_PROFILE):
            return __assign(__assign({}, state), { loading: false, updateSucceeded: true, verifyId: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.VERIFY_STATUS):
            return __assign(__assign({}, state), { verifyStatus: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.RENEW_IDOLOGY_URL):
            return __assign(__assign({}, state), { verifyId: action.payload });
        case types_1.RESET:
            return __assign({}, INITIAL_STATE);
        case (0, action_type_util_1.SUCCESS)(types_1.SOCIAL_CONNECT):
            return __assign({}, state);
        case (0, action_type_util_1.FAILURE)(types_1.GET_TERMS_AND_CONDITIONS):
            return __assign(__assign({}, state), { checkTermsAndConditions: null });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_TERMS_AND_CONDITIONS):
            return __assign(__assign({}, state), { checkTermsAndConditions: action.payload });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_TWITTER_REQUEST_TOKEN):
            return __assign(__assign({}, state), { twitterRequestToken: action.payload.oauth_token, loading: false });
        case (0, action_type_util_1.SUCCESS)(types_1.GET_INSTAGRAM_ACCESS_TOKEN):
        case (0, action_type_util_1.SUCCESS)(types_1.GET_TWITTER_OAUTH_TOKEN):
            return __assign(__assign({}, state), { loading: false });
        default:
            return state;
    }
};
var persistConfig = {
    key: 'profile',
    storage: storage_1.default,
    whitelist: ['checkTermsAndConditions']
};
exports.default = (0, redux_persist_1.persistReducer)(persistConfig, ProfileReducer);
//# sourceMappingURL=reducers.js.map